import { useMutation } from '@tanstack/react-query'

import { TANSTACK_QUERY_KEY } from '@/constants/tanstack-query'
import { queryClient } from '@/context'

import { IHttpError } from '../../core'
import {
  AccessCodeModel,
  IGenerateAccessCodePayload,
  IGenerateReferralCodeRes,
  ILinkWalletWithReferralCodeParams,
  ILinkWalletWithReferralCodeRes,
} from '../models'

export function useMutationGenerateReferralCode() {
  return useMutation<IGenerateReferralCodeRes, IHttpError, IGenerateAccessCodePayload>({
    mutationFn: async (payload) => {
      const res = await AccessCodeModel.generateAccessCode(payload)
      return res.data
    },
  })
}

export function useMutationLinkWalletWithReferralCode() {
  return useMutation<ILinkWalletWithReferralCodeRes, IHttpError, ILinkWalletWithReferralCodeParams>({
    mutationFn: async (payload) => {
      const res = await AccessCodeModel.linkWalletWithReferralCode(payload)
      queryClient.invalidateQueries({ queryKey: [TANSTACK_QUERY_KEY.ACCESS_CODE.GET_REFERRER_INFO] })
      return res.data
    },
  })
}
